import reviewCarIcon from "../../../assets/images/review_car.svg";
import { useIsMobile } from "../../../hooks/use-mobile";
import { Link, usePage } from "@inertiajs/react";
import { Button } from "../../ui";
import { trackEvaluationButtonClick } from "../../../utils/redirectToNewReview";

const Header = ({
  showEvaluationButton = true,
  showBlogLink = false,
}: {
  showEvaluationButton?: boolean;
  showBlogLink?: boolean;
}) => {
  const isMobile = useIsMobile();
  // Detection SSR-safe de la route active via usePage().url (jamais window.location
  // au top-level : casserait le rendu serveur / l'hydratation). La liste /blog et
  // les pages article (/blog/articles/...) sont toutes "actives" pour le lien Blog.
  const { url } = usePage();
  const pathname = url.split("?")[0];
  const isBlogActive = pathname === "/blog" || pathname.startsWith("/blog/");
  return (
    <div className="shadow-xs">
      <div className="flex justify-between items-center p-4 w-full container mx-auto">
        <Link href="/">
          <img
            src={reviewCarIcon}
            alt="Review Car"
            className="w-[175px] cursor-pointer"
          />
        </Link>
        <div className="flex items-center gap-4">
          <>
            <Button variant="link" asChild>
              <Link href="/about">Qui sommes-nous ?</Link>
            </Button>
            {showBlogLink && (
              <Button
                variant="link"
                asChild
                className={
                  isBlogActive ? "underline underline-offset-4" : undefined
                }
              >
                <Link href="/blog">Blog</Link>
              </Button>
            )}
          </>
          {!isMobile && (
            <>
              <Button variant="outline" asChild>
                <Link href="/vehicles">Rechercher un véhicule</Link>
              </Button>
              {showEvaluationButton && (
                <Button asChild>
                  <Link
                    href="/reviews/new"
                    onClick={() =>
                      trackEvaluationButtonClick({ page_type: "Header" })
                    }
                  >
                    Évaluer mon véhicule
                  </Link>
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
